export const SLIDER_INTERVAL = 3000 // 3 seconds
